export const IBANMandatoryCountries = [
	'Albania',
	'Andorra',
	'Austria',
	'Azerbaijan',
	'Bahrain',
	'Belgium',
	'Bulgaria',
	'Croatia',
	'Cyprus',
	'Czech Republic',
	'Denmark',
	'Estonia',
	'Finland',
	'France',
	'Georgia',
	'Germany',
	'Greece',
	'Hungary',
	'Iceland',
	'Israel',
	'Italy',
	'Kuwait',
	'Latvia',
	'Lebanon',
	'Liechtenstein',
	'Lithuania',
	'Luxembourg',
	'Moldova',
	'Norway',
	'Pakistan',
	'Palestine',
	'Poland',
	'Portugal',
	'Qatar',
	'Republic of Ireland',
	'Romania',
	'Saudi Arabia',
	'Slovak Republic',
	'Slovenia',
	'Spain',
	'Sweden',
	'Switzerland',
	'The Netherlands',
	'Tunisia',
	'Turkey',
	'United Arab Emirates',
	'United Kingdom',
];
